const CHECKBOX_INPUT = {
  label: 'Billing info for card is same as shipping info',
  name: 'billingInfoSameAsShipping',
};

const COUNTRIES = [
  {
    name: 'United States',
    value: 'US',
  },
  {
    name: 'Canada',
    value: 'CA',
  },
  {
    name: 'United Kingdom',
    value: 'GB',
  },
];

export { CHECKBOX_INPUT, COUNTRIES };
